/**
 * The ONLY way a preview-derived string may become an href/src. Connector
 * output is attacker-influenceable (a malicious or compromised MCP server),
 * so everything that isn't an absolute `https:` URL — `javascript:`, `data:`,
 * `http:`, relative paths, garbage — is dropped (returns null) and the
 * link/image is simply not rendered.
 */
export function safeHttpsUrl(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  try {
    const url = new URL(raw);
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}
